const productCategory = [
    { id : 1, label : "Alaskan Flies", value : "Alaskan Flies"},
    { id : 2, label : "Dry Flies", value : "Dry Flies"},
    { id : 3, label : "Barbless Flies", value : "Barbless Flies"},
    { id : 4, label : "Bass Flies", value : "Bass Flies"},
    { id : 5, label : "Blobs", value : "Blobs"},
    { id : 6, label : "Beaded Nymphs", value : "Beaded Nymphs"},
    { id : 7, label : "Special Dries", value : "Special Dries"},
    { id : 8, label : "Boobies", value : "Boobies"},
    { id : 9, label : "Streamers & Beaded Streamers", value : "Streamers & Beaded Streamers"},
    { id : 10, label : "Buzzer Flies", value : "Buzzer Flies"},
    { id : 11, label : "Salmon Doubles", value : "Salmon Doubles"},
    { id : 12, label : "Salmon Singles", value : "Salmon Singles"},
    { id : 13, label : "Saltwaters", value : "Saltwaters"},
    { id : 14, label : "Pike", value : "Pike"},
    { id : 15, label : "Czech Nymps and Gamarus", value : "Czech Nymps and Gamarus"},
    { id : 16, label : "Conehead Streamers", value : "Conehead Streamers"},   
    { id : 17, label : "Wets", value : "Wets"},
    { id : 18, label : "Jiggy", value: "Jiggy"},
]


export default productCategory
